<div class="pager" [attr.data-automation-id]="automationId + '-container'">
    <div class="pager-buttons">
        <button [disabled]="currentPage == 1" (click)="loadData('first')"
            [attr.data-automation-id]="automationId + '-first-page-button'"><i class="fa fa-fast-backward"></i></button>
        <button [disabled]="currentPage == 1" (click)="loadData('previous')"
            [attr.data-automation-id]="automationId + '-prev-page-button'"><i class="fa fa-backward"></i></button>
        <div class="pager-input">
            <input type="text"
                onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
                name="page" [(ngModel)]="currentPage" (keydown.enter)="loadData()" [disabled]="totalPages <= 1"
                [attr.data-automation-id]="automationId + '-page-input'" />
            <span [attr.data-automation-id]="automationId + '-total-pages-label'">of {{totalPages | number}}</span>
        </div>
        <button [disabled]="currentPage == totalPages" (click)="loadData('next')"
            [attr.data-automation-id]="automationId + '-next-page-button'"><i class="fa fa-forward"></i></button>
        <button [disabled]="currentPage == totalPages" (click)="loadData('last')"
            [attr.data-automation-id]="automationId + '-last-page-button'"><i class="fa fa-fast-forward"></i></button>
        <button (click)="loadData()" [attr.data-automation-id]="automationId + '-refresh-button'"
            [attr.title]="'Refresh' + (pagerName ? ' ' + pagerName : '')" [hidden]="isRefreshIconHidden"><i
                class="fa fa-refresh"></i></button>
    </div>
    <div class="pager-template" *ngIf="pagerTemplate">
        <ng-container *ngTemplateOutlet="pagerTemplate"></ng-container>
    </div>
    <div class="pager-index" [attr.data-automation-id]="automationId + '-page-index-label'">
        {{(startIndex + 1) | number}} - {{endIndex | number}} / {{totalItems | number}}</div>
</div>